import React from 'react';
import { Checkbox, TableBody, TableRow, CircularProgress } from '@mui/material';
import { PAGINATION_LIMIT } from '@src/constants';
import { useCheckDubbingRoute } from '@src/hooks/useCheckDubbingRoute';
import { StyledLoadingTable, StyledTableCell } from './index.style';

const CustomTableBody = ({
  page,
  dropTable,
  columns,
  data,
  selection,
  showNumber,
  tableHeight,
  isSelected,
  loading,
  onSelectRow,
  onRowClick,
  isShowCheckbox,
}) => {
  const handleRowClick = (rowId) => {
    if (onRowClick) onRowClick(rowId);
  };
  const isDubbingRoute = useCheckDubbingRoute();

  return (
    <TableBody>
      {loading ? (
        <>
          <StyledLoadingTable tableHeight={tableHeight} dropTable={dropTable}>
            <TableRow
              className={`body-row ${!isDubbingRoute && 'body-row-cursor'}`}
            >
              <StyledTableCell>
                <CircularProgress
                  value={75}
                  className="loading-load-request"
                  size="24px"
                />
              </StyledTableCell>
            </TableRow>
          </StyledLoadingTable>
        </>
      ) : (
        <div
          style={{
            height: data?.length > 5 && tableHeight,
          }}
        >
          {data.map((rowData, index) => (
            <TableRow
              className={`body-row ${!isDubbingRoute && 'body-row-cursor'}`}
              key={rowData.id}
              onClick={() => handleRowClick(rowData.id)}
            >
              {selection && isShowCheckbox && (
                <StyledTableCell
                  className="checkbox-cell"
                  padding="checkbox"
                  align="left"
                  onClick={(e) => e.stopPropagation()}
                >
                  <Checkbox
                    data-id={
                      isSelected(rowData) ? 'unselect-req' : 'select-req'
                    }
                    className="body-checkbox"
                    checked={isSelected(rowData)}
                    onChange={onSelectRow(rowData)}
                  />
                </StyledTableCell>
              )}
              {showNumber && (
                <StyledTableCell className="body-cell" align="center">
                  {(page - 1) * PAGINATION_LIMIT + index + 1}
                </StyledTableCell>
              )}
              {columns.map((column) => (
                <StyledTableCell
                  width={column.width}
                  className="body-cell"
                  align={column.align}
                >
                  {column.render
                    ? column.render(rowData)
                    : rowData[column.field]}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </div>
      )}
    </TableBody>
  );
};

export default CustomTableBody;
